//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import { faChevronDown, faClapperboardPlay } from '@fortawesome/pro-regular-svg-icons';
import AiToolsMixin from '@motionelements/core/src/components/mixins/ai-tools.mixin.js';
import videoCodecMixin from '@motionelements/core/src/components/mixins/video-codec.mixin.js';
import videoCodec2Mixin from '@motionelements/core/src/components/mixins/video-codec-2.mixin.js';
import { uploadToS3Temp } from '@motionelements/core/src/services/upload.service.js';
import { camelCaseKeys } from '@motionelements/core/src/helpers/string.js';
import { downloadElement } from '@motionelements/core/src/services/download.service.js';
//
import clearSourceVideoMixin from '@/components/mixins/clear-source-video.mixin.js';
import libraryProductVideoUpscalingMixin from '@/components/mixins/library-product-video-upscaling.mixin.js';
import aiModelsChaining from '@/components/mixins/ai-models-chaining.mixin.js';
// eslint-disable-next-line
import { generatePredictions, getPrediction } from '@/api/ai-tools.js';

export default {
  name: 'video-upscaler',
  middleware: 'route-guard',
  components: {
    VideoFilePlaceholder: () => import('@/components/core/VideoFilePlaceholder.vue'),
    BaseInvalidFeedback: () => import('@motionelements/core/src/components/ui/form/BaseInvalidFeedback.vue'),
    ToolImageLayout: () => import('@/components/core/ToolImageLayout.vue'),
    SourceFileUploader: () => import('@/components/core/SourceFileUploader.vue'),
    DemoSourceImages: () => import('@/components/tools/DemoSourceImages.vue'),
    BaseImg: () => import('@/components/core/BaseImgExtended.vue'),
    VideoInfo: () => import('@/components/predictions/VideoInfo.vue'),
    ClearSourceVideoModal: () => import('@/components/modals/ClearSourceVideoModal.vue'),
  },
  mixins: [AiToolsMixin, videoCodecMixin, videoCodec2Mixin, clearSourceVideoMixin, libraryProductVideoUpscalingMixin, aiModelsChaining],
  data() {
    return {
      faChevronDown,
      faClapperboardPlay,
      //
      fileSizeLimit: 4, // 4Gb
      acceptedFileExtensions: ['mp4', 'mov'],
      originalFileName: '',
      //
      selectFormatVisible: false,
      form: {
        video: '',
        model: 'video_upscale_2x',
        format: 'avc', // avc - h.264, hevc - h.265
      },
      models: [
        {
          id: 'video_upscale_2x',
          label: '200%',
          factor: 2,
        },
        {
          id: 'video_upscale_4x',
          label: '400%',
          factor: 4,
        },
      ],
      formats: [
        {
          id: 'avc',
          label: 'H.264',
        },
        {
          id: 'hevc',
          label: 'H.265',
        },
      ],
      //
      allowedCodecs: [
        // 'ap4h', // ProRes4 444 (For Alpha)
        'avc1', // H.264
        'hev1', // H.265/HEVC
        'hvc1', // H.265/HEVC
        // 'rle', // Quicktime Animation
      ],
      minResolutions: [ // 640x360 OR 360x640
        { width: 640, height: 360 },
        { width: 360, height: 640 },
      ],
      maxResolutions: [
        // { width: 2560, height: 1440 }, // 2560x1440 OR 1440x2560
        // { width: 1440, height: 2560 },
        { width: 1920, height: 1080 }, // 1920x1080 OR 1080x1920
        { width: 1080, height: 1920 },
      ],
      //
      isLoading: false,
      isError: false,
      errorMessage: '',
      //
      progress: 0,
      loadingProgressMessage: '',
      //
      duration: 0,
      width: 0,
      height: 0,
      size: 0,
      codecs: [],
      //
      predictionId: null,
      isPredictionLoading: false,
      predictionPrice: 0,
      interval: null,
      //
      outputVideo: null,
      outputThumbnail: null,
      outputFileName: '',
      outputWidth: 0,
      outputHeight: 0,
      outputModel: '',
      outputVideoPreview: null,
      //
      demo: '',
      preview: '',
      inputFilePreview: '',
      demoItems: [
        {
          labelImage: 'https://static.moele.me/img/studio-ai/video_upscaler/anime-girl.png?auto=format&w=88',
          value: 'https://static.moele.me/img/studio-ai/video_upscaler/anime-girl.mp4',
        },
        {
          labelImage: 'https://static.moele.me/img/studio-ai/video_upscaler/lion-cub.png?auto=format&w=88',
          value: 'https://static.moele.me/img/studio-ai/video_upscaler/lion-cub.mp4',
        },
        {
          labelImage: 'https://static.moele.me/img/studio-ai/video_upscaler/corporate-office.png?auto=format&w=88',
          value: 'https://static.moele.me/img/studio-ai/video_upscaler/corporate-office.mp4',
        },
      ],
    };
  },
  validations: {
    form: {
      video: {
        required,
        errorMessage() {
          return this.errorMessage === '';
        },
      },
    },
  },
  computed: {
    ...mapState({
      isLoggedIn: state => state.user.isLoggedIn,
      isUserEmailVerified: state => state.user.member.emailVerified,
      coins: state => state.user.member.coins,
    }),
    tool() {
      return {
        ...this.aiTools.find(({ id }) => id === this.aiToolsIds.VIDEO_UPSCALER),
        price: `${this.computedPice || this.predictionPrice}`,
      };
    },
    resolution() {
      return `${this.width} x ${this.height}`;
    },
    totalPixels() {
      return this.width * this.height;
    },
    upscaledResolution() {
      return (factor) => (this.upscaledTotalPixels(factor) > 8294400 ? '3840 x 2160' : `${this.width * factor} x ${this.height * factor}`);
    },
    upscaledTotalPixels() {
      return (factor) => this.width * factor * this.height * factor;
    },
    factor() {
      const model = this.models.find(({ id }) => id === this.form.model);
      return _.get(model, 'factor', 0);
    },
    upscaleFactorText() {
      return (modelId) => {
        const model = this.models.find(({ id }) => id === modelId);
        return model ? model.label : '';
      };
    },
    outputResolution() {
      return `${this.outputWidth} x ${this.outputHeight}`;
    },
    computedPice() {
      // return Math.round(this.duration * 0.4);
      const roundedDuration = Math.ceil(this.duration / 5) * 5;
      const blocks = roundedDuration / 5;
      return blocks * 2;
    },
    modelsFiltered() {
      if (this.upscaledTotalPixels(2) >= 8294400) {
        return this.models.filter(({ factor }) => factor === 2);
      }
      return this.models;
    },
    isVideoLoaded() {
      return !!this.form.video;
    },
    sizeInGb() {
      return (this.size / 1073741824).toFixed(6);
    },
    acceptedFileExtensionsWithDot() {
      return this.acceptedFileExtensions.map(extension => `.${extension}`);
    },
    //
    productId() {
      return this.$route.query.sku;
    },
  },
  watch: {
    'form.video'(val, oldVal) {
      console.log('======== WATCH form.video ', val, oldVal);
      // if (val) {
        this.preview = val;
        this.demo = '';
      // }
    },
    demo(val, oldVal) {
      console.log('======== WATCH demo ', val, oldVal);
      if (val) this.preview = val;
    },
  },
  mounted() {
    // handling already generated prediction
    if (this.$route.query.prediction_id) {
      this.predictionId = this.$route.query.prediction_id;
      this.isPredictionLoading = true;
      this.pollPrediction();
    }
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  methods: {
    handleOnDrop(event) {
      if (!this.isLoggedIn) {
        this.$bvModal.show('sign-up-modal');
        return;
      }
      if (!this.isUserEmailVerified) {
        this.$bvModal.show('unverified-modal');
        return;
      }
      // console.log(event);
      this.outputVideo = null;
      this.outputVideoPreview = null;
      this.isError = false;
      this.isLoading = false;
      this.errorMessage = '';
      this.$v.form.$reset();
      if (this.interval) {
        clearInterval(this.interval);
        this.isPredictionLoading = false;
      }
      if (this.$route.query.prediction_id) {
        this.$router.push({ query: {} });
      }
      //
      const files = event.target.files || event.dataTransfer.files;
      const file = files && files[0];
      if (file) {
        this.checkFileSize(file) // simple check of file.size
          .then(() => {
            this.startVideoChecking(file); // checking with mp4box
          });
      }
    },
    async startVideoChecking(file) {
      try {
        await this.checkVideoInfo(file);
        await this.checkDuration();
        await this.checkMinResolution();
        await this.checkMaxResolution();
        await this.checkVideoCodec();
        //
        const fileName = file.name;
        this.originalFileName = fileName;
        const fileExtension = fileName.split('.').pop().toLowerCase();
        const randomName = this.$uuid();
        const uploadFilename = `${randomName}.${fileExtension}`;
        this.isLoading = true;
        uploadToS3Temp('search', file, uploadFilename, {
          onUploadProgress: progressEvent => {
            this.progress = Math.round((progressEvent.loaded / progressEvent.total) * 100);
          },
        })
          .then((response) => {
            console.log(response);
            this.form.video = response.url;
          })
          .catch(err => {
            console.error(err);
            this.reset();
          })
          .finally(() => {
            this.progress = null;
            this.isLoading = false;
          });
      } catch (err) {
        console.error(err);
      }
    },
    checkVideoInfo(file) {
      console.log('========== checkVideoInfo');
      this.isLoading = true;
      return this.getVideoInfoByChunk(file)
        .then((info) => {
          // console.log(info);
          info = camelCaseKeys(info);
          this.codecs = this.getVideoCodecs(info);
          this.duration = Math.round(info.duration / info.timescale);
          this.width = this.getVideoTrackResolution(info).width;
          this.height = this.getVideoTrackResolution(info).height;
          console.log(this.codecs);
          return info;
        })
        .catch(err => {
          console.error(err);
          console.log('%c ONLY h.264, h.265, prores4444, quicktime animation codecs accepted', 'color: red');
          this.errorMessage = this.$t('search.accepts_{formats}', { formats: 'h.264, h.265, prores4444, quicktime animation codecs' });
          throw Error(err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    //
    checkFileSize(file) {
      console.log('========== checkFileSize');
      this.size = file.size;
      const fileExtension = file.name.split('.').pop().toLowerCase();
      const isAcceptedFormat = this.acceptedFileExtensions.includes(fileExtension);
      return new Promise((resolve) => {
        if (this.sizeInGb > this.fileSizeLimit || !isAcceptedFormat) {
          this.errorMessage = this.$t('studio_ai.errors.please_upload_{formats}_{size}', {
            formats: this.acceptedFileExtensionsWithDot.join(', '),
            size: `${this.fileSizeLimit} Gb`,
          });
        } else {
          resolve();
        }
      });
    },
    checkDuration() {
      console.log('========== checkDuration');
      return new Promise((resolve) => {
        if (this.duration < 1) {
          this.errorMessage = this.$t('error.must_be_at_least_{number}', { number: '1s' });
        } else if (this.duration > 180) {
          this.errorMessage = this.$t('error.must_be_less_than_{number}', { number: '180s' });
        } else {
          resolve();
        }
      });
    },
    checkMinResolution() {
      console.log('========== checkMinResolution');
      return new Promise((resolve) => {
        if (
          (this.width < this.minResolutions[0].width && this.height < this.minResolutions[0].height)
          || (this.width < this.minResolutions[1].width && this.height < this.minResolutions[1].height)
        ) {
          console.log('%c min resolution 640 x 360 or 360 x 640', 'color: red');
          this.errorMessage = this.$t('studio_ai.errors.upload_file_larger_than_{dimension}', {
            dimension: `${this.minResolutions[0].width} x ${this.minResolutions[0].height}, ${this.minResolutions[1].width} x ${this.minResolutions[1].height}`,
          });
        } else {
          console.log('%c min resolution ACCEPTED', 'color: green');
          resolve();
        }
      });
    },
    checkMaxResolution() {
      console.log('========== checkMaxResolution');
      return new Promise((resolve) => {
        if (
          (this.width > this.maxResolutions[0].width && this.height > this.maxResolutions[0].height)
          || (this.width > this.maxResolutions[1].width && this.height > this.maxResolutions[1].height)
        ) {
          console.log('%c max resolution 2560 x 1440 or 1440 x 2560', 'color: red');
          this.errorMessage = this.$t('studio_ai.errors.upload_file_smaller_than_{dimension}', {
            dimension: `${this.maxResolutions[0].width} x ${this.maxResolutions[0].height}, ${this.maxResolutions[1].width} x ${this.maxResolutions[1].height}`,
          });
        } else {
          console.log('%c max resolution ACCEPTED', 'color: green');
          resolve();
        }
      });
    },
    checkVideoCodec() {
      console.log('========== checkVideoCodec');
      return new Promise((resolve) => {
        if (this.codecs.length === 1) { // should have only 1 video track
          const videoCodec = this.codecs[0];
          const isCodecAllowed = this.allowedCodecs.includes(videoCodec);
          if (isCodecAllowed) {
            console.log(`%c Codec: ${videoCodec}`, 'color: green');
            console.log('%c ACCEPTED', 'color: green');
            resolve();
          } else {
            console.log('%c ONLY h.264, h.265, prores4444, quicktime animation codecs accepted', 'color: red');
            this.errorMessage = this.$t('search.accepts_{formats}', { formats: 'h.264, h.265, prores4444, quicktime animation codecs' });
          }
        } else {
          console.error('%c no tracks', 'color: red');
        }
      });
    },
    //
    handleReset() {
      if (this.productId && this.showClearSourceVideoModal) {
        this.$bvModal.show('clear-source-video-modal');
      } else {
        this.reset();
      }
    },
    reset() {
      this.$store.dispatch('leave/setIsProgress', false);
      if (document.querySelector('input[type=file]')) {
        document.querySelector('input[type=file]').value = null;
      }
      this.$v.$reset();
      if (this.$route.query.prediction_id || this.productId) {
        this.$router.push({ query: {} });
      }
      if (this.interval) {
        clearInterval(this.interval);
      }
      this.form.video = '';
      this.form.model = 'video_upscale_2x';
      this.form.format = 'avc';
      this.isLoading = false;
      this.isError = false;
      this.errorMessage = '';
      this.progress = 0;
      this.loadingProgressMessage = '';
      this.duration = 0;
      this.width = 0;
      this.height = 0;
      this.codecs = [];
      this.inputFilePreview = '';
      //
      this.outputVideo = null;
      this.outputThumbnail = null;
      this.outputFileName = '';
      this.outputWidth = 0;
      this.outputHeight = 0;
      this.outputModel = '';
      this.predictionPrice = 0;
    },
    handleGeneratePredictions() {
      this.$v.form.$touch();
      if (this.$v.form.$pending || this.$v.form.$error) return;
      if (!this.$v.form.$invalid) {
        if (this.productId && this.productSku) {
          this.isPredictionLoading = true;
          downloadElement({
            method: 'subscription',
            sku: this.productSku,
          })
            .then(() => {
              this.$store.dispatch('leave/setIsProgress', true);
              this.generatePredictions();
            })
            .catch(err => {
              this.isPredictionLoading = false;
              console.error(err);
            });
        } else {
          this.$store.dispatch('leave/setIsProgress', true);
          this.generatePredictions();
        }
      }
    },
    generatePredictions() {
      console.log('========== generate prediction');
      this.isPredictionLoading = true;
      const params = {
        ...this.form,
        duration: this.duration,
        original_filename: this.originalFileName,
      };
      if (this.productId) {
        params.input = { sku: this.productId };
        delete params.video;
      }
      generatePredictions(params)
        .then(({ data: { data: prediction } }) => {
          console.log('========= PREDICTION STATUS: ', prediction.status);
          this.$store.commit('user/setCoins', this.coins - prediction.amount);
          this.predictionId = prediction.id;
          this.$router.push({ query: { prediction_id: prediction.id } });
          this.pollPrediction();
        })
        .catch(err => {
          console.error(err);
          this.isPredictionLoading = false;
          this.isError = true;
          this.$store.dispatch('leave/setIsProgress', false);
        });
    },
    pollPrediction() {
      console.log('========== poll prediction');
      getPrediction(this.predictionId)
        .then(({ data: { data: prediction } }) => {
          console.log('========= PREDICTION STATUS: ', prediction.status);
          if (!['succeeded', 'failed'].includes(prediction.status)) {
            this.interval = setInterval(() => {
              this.getPrediction();
            }, 10000);
          }
          this.handlePredictionResponse(prediction);
        })
        .catch(err => {
          console.error(err);
          this.isPredictionLoading = false;
          this.isError = true;
          this.$store.dispatch('leave/setIsProgress', false);
        });
    },
    getPrediction() {
      console.log('========== get prediction');
      return getPrediction(this.predictionId)
        .then(({ data: { data: prediction } }) => {
          console.log('========= PREDICTION STATUS: ', prediction.status);
          this.handlePredictionResponse(prediction);
        })
        .catch(err => {
          console.error(err);
          this.isPredictionLoading = false;
          this.isError = true;
        });
    },
    handlePredictionResponse(prediction) {
      console.log('========== handle prediction response');
      if (['succeeded', 'failed'].includes(prediction.status)) {
        clearInterval(this.interval);
        this.isPredictionLoading = false;
        this.$store.dispatch('leave/setIsProgress', false);
      }
      if (prediction.status === 'succeeded') {
        console.log(prediction);
        this.outputVideo = _.get(prediction, 'output.files[0].url', null);
        this.outputThumbnail = _.get(prediction, 'output.files[0].thumbnail.url', null);
        this.outputFileName = _.get(prediction, 'output.files[0].name', '');
        this.outputModel = _.get(prediction, 'model', '');
        this.outputVideoPreview = _.get(prediction, 'output.files[0].preview.url', null);
        //
        this.outputWidth = _.get(prediction, 'output.files[0].width', 0);
        this.outputHeight = _.get(prediction, 'output.files[0].height', 0);
        // already generated prediction
        this.predictionPrice = _.get(prediction, 'amount', 0);
        this.duration = _.get(prediction, 'input.duration', 0);
        this.form.video = _.get(prediction, 'input.video', '');
        this.form.model = _.get(prediction, 'model', 'video_upscale_2x');
        this.width = this.outputWidth / this.factor;
        this.height = this.outputHeight / this.factor;
      }
    },
  },
};
